import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import UserStore from "./store/UserStore";
import ItemsStore from "./store/ItemsStore";
import ErrorHandler from "./hocs/ErrorHandler";
import OrdersStore from "./store/OrdersStore";
import CartStore from "./store/CartStore";
import {BrowserRouter as Router} from "react-router-dom";
import {HelmetProvider} from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
export const Context = createContext(null);

root.render(
    <Context.Provider value={{
        user: new UserStore(),
        items: new ItemsStore(),
        orders: new OrdersStore(),
        cart: new CartStore()
    }}>
        <HelmetProvider>
            <Router>
                <ErrorHandler>
                    <App />
                </ErrorHandler>
            </Router>
        </HelmetProvider>
    </Context.Provider>
);

